@import "~/styles/variables";

.GridCell {
  min-width: 0;

  &.valign {
    &_top {
      align-self: flex-start;
    }

    &_center {
      align-self: center;
    }

    &_bottom {
      align-self: flex-end;
    }

    &_stretch {
      align-self: stretch;
    }
  }

  &.width {
    &_fixed {
      flex: none;
    }
    &_fill {
      flex: auto;
    }
    &_1\/12 {
      flex: 0 0 8.333%;
    }
    &_1\/6,
    &_2\/12 {
      flex: 0 0 16.666%;
    }
    &_1\/4,
    &_3\/12 {
      flex: 0 0 25%;
    }
    &_1\/3,
    &_4\/12 {
      flex: 0 0 33.333%;
    }
    &_5\/12 {
      flex: 0 0 41.666%;
    }
    &_1\/2,
    &_6\/12 {
      flex: 0 0 50%;
    }
    &_7\/12 {
      flex: 0 0 58.333%;
    }
    &_2\/3,
    &_8\/12 {
      flex: 0 0 66.666%;
    }
    &_3\/4,
    &_9\/12 {
      flex: 0 0 75%;
    }
    &_5\/6,
    &_10\/12 {
      flex: 0 0 83.333%;
    }
    &_11\/12 {
      flex: 0 0 91.666%;
    }
    &_1,
    &_12\/12 {
      flex: 0 0 100%;
    }
  }

  @each $size, $val in $space-sizes {
    &.padding_#{$size} {
      padding: map-get($space-sizes, $size);
    }
    &.hpadding_#{$size} {
      padding: 0 map-get($space-sizes, $size);
    }
    &.vpadding_#{$size} {
      padding: map-get($space-sizes, $size) 0;
    }
  }

  &.clickable {
    cursor: pointer;
  }
}
